import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';

@Injectable()
export class DataPackageService {

    constructor(
      private apiService: ApiService
    ) {
      this.apiService.init();
    }

    getDataPackages(): Observable<any[]> {
      return this.apiService.client.dataPackages.GET()
        .map((res) => {
          return this.apiService.handleResponse(res).results;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/api/data-package.service.ts